import Vue from 'vue';
import Router from 'vue-router';

import NotFound from "./pages/NotFound";


Vue.use(Router);

let router = new Router({
  // mode: "hash",//1、hash哈希：有#号。2、history历史：没有#号
  mode:"history",//1、hash哈希：有#号。2、history历史：没有#号，需要配置环境
  base: process.env.BASE_URL, //自动获取根目录路径
  scrollBehavior: (to, from, position) => {
    if (position) {
      return position
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("./pages/home/main"),//路由懒加载解决首屏加载慢，性能优化
      meta: { keepAlive: false },
      redirect: "/index",
      children: [
        {
          path: "index",
          name: "index",
          component: () => import("./pages/home/index"),
          meta: { keepAlive: true, title: "数字藏品" }
        },
        {
          path: "goods",
          name: "goods",
          component: () => import("./pages/home/goods"),
          meta: { keepAlive: false, title: "市场" },
        },
        {
          path: "user",
          name: "user",
          component: () => import("./pages/user/ucenter"),
          meta: { keepAlive: false, title: "我的" }
        }
      ]
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./pages/home/login"),
      meta: { keepAlive: false, title: "登录" }
    },
    {
      path: "/reg",
      name: "reg",
      component: () => import("./pages/home/reg"),
      meta: { keepAlive: false, title: "注册" }
    },

    {
      path: "/forgot",
      name: "forgot",
      component: () => import("./pages/home/forgot"),
      meta: { auth: false, title: "找回密码" }
    },

    {
      path: "/news/:id",
      name: "news",
      component: () => import("./pages/home/news"),
      meta: { keepAlive: false, title: "详情" }
    },

    {
      path: "/page/:id",
      name: "page",
      component: () => import("./pages/home/page"),
      meta: { keepAlive: false, title: "详情" }
    },

    {
      path: "/goods/details",
      name: "goods-details",
      component: () => import("./pages/home/goods/details"),
    },

    
    {
      path: "/goods/order",
      name: "goods-order",
      component: () => import("./pages/home/goods/order"),
      meta: { keepAlive: false, title: "确认订单" }
    },

    {
      path: "/user/order",
      name: "my-order",
      component: () => import("./pages/user/order"),
      redirect: "/user/order/list",
      meta: { auth: false },
      children: [
        {
          path: "list",
          name: "order-list",
          component: () => import("./pages/user/order/list"),
          meta: { auth: false }
        },
        // {
        //     path:"review",
        //     name:"order-review",
        //     component:()=>import("./pages/user/order/review"),
        //     meta:{auth:true}
        // }
      ]
    },
    {
      path: "/user/order/details",
      name: "order-details",
      component: () => import("./pages/user/order/details"),
      meta: { auth: false, title: "订单详情" }
    },
    {
      path: "/user/order/vantlist",
      name: "order-vantlist",
      component: () => import("./pages/user/order/vantlist"),
      meta: { auth: false, title: "订单详情" }
    },


    {
      path: "/user/collection",
      name: "collection",
      component: () => import("./pages/user/collection"),
      meta: { auth: true, title: "收藏记录" }
    },

    {
      path: "/user/achievement",
      name: "achievement",
      component: () => import("./pages/user/achievement"),
      meta: { auth: false, title: "我的成就" }
    },

    {
      path: "/user/set",
      name: "user-set",
      component: () => import("./pages/user/set"),
      meta: { auth: true, title: "设置" }
    },

    {
      path: "/user/editPwd",
      name: "user-editPwd",
      component: () => import("./pages/user/editPwd"),
      meta: { auth: true, title: "修改密码" }
    },



    {
      path: "/user/profile",
      name: "profile",
      component: () => import("./pages/user/profile"),
      meta: { auth: true, title: "编辑资料" }
    },
    {
      path: "/user/profile/uploadhead",
      name: "uploadhead",
      component: () => import("./pages/user/profile/uploadhead"),
      meta: { auth: true, title: "选择头像" }
    },
    {
      path: "/user/set/verify",
      name: "user-set-verify",
      component: () => import("./pages/user/set/verify"),
      meta: { auth: true, title: "实名认证" }
    },
    {
      path: "/user/address",
      name: "user-address",
      component: () => import("./pages/user/address"),
      meta: { auth: true, title: "收货地址" }
    },

    {
      path: "/user/address/edit",
      name: "user-address-edit",
      component: () => import("./pages/user/address/edit"),
      meta: { auth: true, title: "收货地址" }
    },

    {
      path: "/user/treasure/details",
      name: "user-treasure-details",
      component: () => import("./pages/user/treasure/details"),
      meta: { auth: false, title: "我的藏品" }
    },

    {
      path: "/user/treasure/sethead",
      name: "user-treasure-sethead",
      component: () => import("./pages/user/treasure/sethead"),
      meta: { auth: false, title: "设置头像" }
    },
    {
      path: '*',
      component: NotFound
    }
    
  ]
});


router.beforeEach((to, from, next) => {
  
  if (to.meta.auth) {
    if (Boolean(localStorage['isLogin'])) {
      next();
    } else {
      next("/login");
    }

  } else {
    next();
  }

});

export default router;